import {
    GET_ALL_PRODUCTS,
    GET_ALL_ACTIVE_AUCTIONS,
    GET_SINGLE_PROJECT,
    GET_SINGLE_PROJECT_TIMES,
    GET_SINGLE_PROJECT_LABEL,
    GET_ALL_BID_HISTORY,
    GET_ALL_PROXY_HISTORY,
    GET_ALL_API_LOGS,
    GET_ALL_TTWBID_HISTORY,
    RECONCILIATION,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_ALL_ROYALTY_INPUTS,
    GET_SYNC_DASHBOARD_DATA,
    GET_ALL_PROJECT_ACCESS,
    GET_ALL_OFFERS,
    GET_EDIT_ACTION_STATUS,
    CLEAR_RESPONSE_EDIT,
} from './productTypes'

export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_ALL_PRODUCTS:
            return {
                ...state,
                all_products: action.payload,
            }
        case GET_ALL_ACTIVE_AUCTIONS:
            return {
                ...state,
                activelots: action.payload,
            }
        case GET_EDIT_ACTION_STATUS:
            return {
                ...state,
                edit_action_status: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        case CLEAR_RESPONSE_EDIT:
            return {
                ...state,
                edit_action_status: null,
            }
        case GET_SINGLE_PROJECT:
            return {
                ...state,
                single_project: action.payload,
            }
        case GET_SINGLE_PROJECT_TIMES:
            return {
                ...state,
                project_timing_config: action.payload,
            }

        case GET_SINGLE_PROJECT_LABEL:
            return {
                ...state,
                single_project_label: action.payload,
            }
        case GET_ALL_BID_HISTORY:
            return {
                ...state,
                search_allbidhistory: action.payload,
            }
        case GET_ALL_PROXY_HISTORY:
            return {
                ...state,
                search_allproxyhistory: action.payload,
            }

        case GET_ALL_API_LOGS:
            return {
                ...state,
                search_allapilogs: action.payload,
            }
        case GET_ALL_TTWBID_HISTORY:
            return {
                ...state,
                search_allttwbidhistory: action.payload,
            }
        case GET_ALL_PROJECT_ACCESS:
            return {
                ...state,
                all_project_access_req: action.payload,
            }
        case RECONCILIATION:
            console.log('reconciliation payload', action.payload)
            return {
                ...state,
                reconcilation: action.payload[0],
            }
        case GET_ALL_ROYALTY_INPUTS:
            return {
                ...state,
                all_royalty_inputs: action.payload,
            }
        case GET_ALL_OFFERS:
            return {
                ...state,
                all_offers: action.payload,
            }
        case GET_SYNC_DASHBOARD_DATA:
            return {
                ...state,
                mainDashboardSync: action.payload,
            }

        default:
            return state
    }
}
